import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class EventRegistration {
    public event_registrationID: string = '';
    public eventID: string = '';
    public paymentID: string = '';
    public initiatorID: string = '';
    public beneficiaryIDs: string[] = [];
    public doc_base_url: string = '';
    public beneficiary_doc_ics: string[] = [];
    public beneficiary_doc_passports: string[] = [];
    public dietary_options: number[] = [];
    public public_beneficiary_ids: string[] = [];
    public public_beneficiary_salutations: string[] = [];
    public public_beneficiary_fullnames: string[] = [];
    public public_beneficiary_emails: string[] = [];
    public public_beneficiary_phones: string[] = [];
    public public_beneficiary_designations: string[] = [];
    public public_beneficiary_doc_ics: string[] = [];
    public public_beneficiary_doc_passports: string[] = [];
    public public_beneficiary_rpm_nos: string[] = [];
    public public_dietary_options: number[] = [];
    public hrd_claim_status: number = 0;
    public hrd_grant_status: number = 0;
    public datetime_created: Date = new Date;

    //extras (not on db)
    public event_regRefIDs: string[] = [];

    constructor(
        event_registrationID: string,
        eventID: string,
        paymentID: string,
        initiatorID: string,
        beneficiaryIDs: string,
        doc_base_url: string,
        beneficiary_doc_ics: string,
        beneficiary_doc_passports: string,
        dietary_options: string,
        public_beneficiary_ids: string,
        public_beneficiary_salutations: string,
        public_beneficiary_fullnames: string,
        public_beneficiary_emails: string,
        public_beneficiary_phones: string,
        public_beneficiary_designations: string,
        public_beneficiary_doc_ics: string,
        public_beneficiary_doc_passports: string,
        public_beneficiary_rpm_nos: string,
        public_dietary_options: string,
        hrd_claim_status: string,
        hrd_grant_status: string,
        datetime_created: string,
        event_regRefIDs: string
    ) {
        this.event_registrationID = this[CheckNotNull](event_registrationID) ? event_registrationID : '';
        this.eventID = this[CheckNotNull](eventID) ? eventID : '';
        this.paymentID = this[CheckNotNull](paymentID) ? paymentID : '';
        this.initiatorID = this[CheckNotNull](initiatorID) ? initiatorID : '';
        this.beneficiaryIDs = this[CheckNotNull](beneficiaryIDs) ? beneficiaryIDs.split(',') : [];
        this.doc_base_url = this[CheckNotNull](doc_base_url) ? doc_base_url : '';
        this.beneficiary_doc_ics = this[CheckNotNull](beneficiary_doc_ics) ? beneficiary_doc_ics.split(',') : [];
        this.beneficiary_doc_passports = this[CheckNotNull](beneficiary_doc_passports) ? beneficiary_doc_passports.split(',') : [];
        this.dietary_options = this[CheckNotNull](dietary_options) ? dietary_options.split(',').map((option: string) => parseInt(option)) : [];
        this.public_beneficiary_ids = this[CheckNotNull](public_beneficiary_ids) ? public_beneficiary_ids.split(',') : [];
        this.public_beneficiary_salutations = this[CheckNotNull](public_beneficiary_salutations) ? public_beneficiary_salutations.split(',') : [];
        this.public_beneficiary_fullnames = this[CheckNotNull](public_beneficiary_fullnames) ? public_beneficiary_fullnames.split(',') : [];
        this.public_beneficiary_emails = this[CheckNotNull](public_beneficiary_emails) ? public_beneficiary_emails.split(',') : [];
        this.public_beneficiary_phones = this[CheckNotNull](public_beneficiary_phones) ? public_beneficiary_phones.split(',') : [];
        this.public_beneficiary_designations = this[CheckNotNull](public_beneficiary_designations) ? public_beneficiary_designations.split(',') : [];
        this.public_beneficiary_doc_ics = this[CheckNotNull](public_beneficiary_doc_ics) ? public_beneficiary_doc_ics.split(',') : [];
        this.public_beneficiary_doc_passports = this[CheckNotNull](public_beneficiary_doc_passports) ? public_beneficiary_doc_passports.split(',') : [];
        this.public_beneficiary_rpm_nos = this[CheckNotNull](public_beneficiary_rpm_nos) ? public_beneficiary_rpm_nos.split(',') : [];
        this.public_dietary_options = this[CheckNotNull](public_dietary_options) ? public_dietary_options.split(',').map((option: string) => parseInt(option)) : [];
        this.hrd_claim_status = this[CheckNotNull](hrd_claim_status) ? parseInt(hrd_claim_status) : 0;
        this.hrd_grant_status = this[CheckNotNull](hrd_grant_status) ? parseInt(hrd_grant_status) : 0;
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : new Date();
        this.event_regRefIDs = this[CheckNotNull](event_regRefIDs) ? event_regRefIDs.split(',') : [];
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default EventRegistration